import {Component} from '@angular/core';
import {environment} from '../environments/environment';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';

import {from} from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'researchdashboard';
    encryptedData: any;
    scrips: any;

    constructor(private modalService: NgbModal, private http: HttpClient, private auth: AuthenticationService) {
    }

    onSearchChange(searchValue: string) {
        this.http.post(environment.baseUrl + 'api/Scrip/SearchForOptionsScripSymbol', this.auth.encryptService({
            'ScripName': searchValue,
            'InstrumentType': 'Equity',
            'SegmentName': 'CASH'
        }), this.auth.getheader())
            .subscribe(
                (val: any) => {
                    this.scrips = this.auth.decryptService(val.Data);
                },
                error => {
                    console.log(error);
                }
            );
    }

    openModal(action, scrip) {
        this.http.post(environment.baseUrl + 'api/Scrip/GetIndustryBySecurityCode', this.auth.encryptService({'SecurityCode': scrip.ScripSymbol}), this.auth.getheader())
            .subscribe(
                (val: any) => {
                    this.scrips = this.auth.decryptService(val.Data);
                },
                error => {
                    console.log(error);
                }
            );
        this.modalService.open(action, {centered: true, windowClass: 'common-modal quote-modal'});
    }
}
